import React, { useState, useEffect } from "react";

function InstitutionDataLoaderBanner({
  content,
  refreshContent,
  onRefresh,
  hiddeRefresh = false,
}) {
  const [countdown, setCountdown] = useState(15);

  useEffect(() => {
    // Safety guard if no trigger callback was supplied to the child component instance
    if (!onRefresh) return;

    const timer = setInterval(() => {
      setCountdown((prevCount) => {
        if (prevCount <= 1) {
          // Fire the backend status check call from layout
          onRefresh();
          // Loop and reset countdown instantly back to baseline operational rhythm
          return 15;
        }
        return prevCount - 1;
      });
    }, 1000);

    // Standard garbage collection clearing hook instance to prevent lingering leaks
    return () => clearInterval(timer);
  }, [onRefresh]);

  return (
    <div className="standard-card-container">
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          gap: "16px",
          alignItems: "center",
          width: "100%",
          justifyContent: "space-between",
        }}
      >
        {/* Header container allowing absolute/flex layout position alignments */}
        <h2
          style={{
            color: "#40464b",
            fontWeight: "500",
            fontSize: "20px",
            margin: 0,
          }}
        >
          {content.title}
        </h2>

        {/* Dynamic Countdown Tag rendering smoothly in the right margin of your heading row */}

        {onRefresh && !hiddeRefresh && (
          <span
            style={{
              fontSize: "12px",
              fontWeight: "600",
              color: "#0052cc",
              backgroundColor: "#e6f0ff",
              padding: "2px 8px",
              borderRadius: "12px",
              border: "1px solid #0052cc",
              whiteSpace: "nowrap",
            }}
          >
            {refreshContent.replace("{countdown}", countdown)}
          </span>
        )}
      </div>
      <p
        style={{
          color: "#6b7280",
          fontSize: "14px",
          lineHeight: "1.6",
          margin: 0,
        }}
      >
        {content.description}
      </p>
    </div>
  );
}

export default InstitutionDataLoaderBanner;
